var exports = {
  "w": "x28a7bf27--4e600c--header",
};

module.exports = exports;
